import React from "react";
import { Typography, Divider } from "@material-ui/core";
import styles from "./BillingItem.module.scss";
import { IBillingItem } from "nodeDetails/types";
import { useDomainNumberFormatter } from "common/useNumberFormatter";
import Row from "./Row";
import {
  getQuantityUnitTranslation,
  getRateUnitTranslation,
  getDisplayBillingPeriod,
} from "nodeDetails/functions/billingResultFunctions";
import { useTranslation } from "react-i18next";

interface Props {
  item: IBillingItem;
  lastItem?: boolean;
}

const BillingItem = ({ item, lastItem }: Props) => {
  const { t } = useTranslation();
  const { formatCurrency, formatNumber } = useDomainNumberFormatter();

  const period = getDisplayBillingPeriod(item.Start, item.End);
  const quantity = item.Quantity
    ? `${formatNumber(item.Quantity)} ${getQuantityUnitTranslation(
        item.QuantityUnit
      )}`
    : "-";
  const rateIncVat = (item.Rate || 0) + (item.RateVat || 0);
  const rateUnit = item.RateUnit ? getRateUnitTranslation(item.RateUnit) : "";
  const rate = item.Rate ? `${formatCurrency(rateIncVat)}/${rateUnit}` : "-";
  const totalIncVat = (item.Total || 0) + (item.TotalVat || 0);
  const total = item.Total ? `${formatCurrency(totalIncVat)}` : "-";
  const totalVat = item.TotalVat ? `${formatCurrency(item.TotalVat)}` : "-";

  return (
    <div>
      <div className={styles.itemHeader}>
        <Typography className={styles.itemTitle} variant="subtitle2">
          {item.PriceComponent.Name}
        </Typography>
      </div>
      <Row label={t("Period")} value={period} />
      <Row label={t("Quantity")} value={quantity} showLine={!!item.Quantity} />
      <Row label={t("Unit price")} value={rate} showLine={!!item.Rate} />
      <Row label={t("Total")} value={total} showLine={!!item.Total} />
      <Row label={t("Tax")} value={totalVat} showLine={!!item.TotalVat} />
      {!lastItem && <Divider className={styles.itemDivider} />}
    </div>
  );
};

export default BillingItem;
